<!-- Goto Button -->
<button
  class="debug-button"
  type="button"
  #gotoButton
  mat-mini-fab
  color="warn"
  [matTooltip]="
    (previousScrollPosition == null
      ? 'debug_panel.goto_debug_panel'
      : 'debug_panel.go_back'
    ) | translate
  "
  (click)="onClickGotoButton()"
>
  <mat-icon>{{
    previousScrollPosition == null ? "bug_report" : "navigation"
  }}</mat-icon>
</button>

<!-- Debug Panel -->
<mat-expansion-panel
  id="debugPanel"
  #debugPanel
  [(expanded)]="debugSettings.isPanelExpanded"
  (expandedChange)="onExpandedChangePanel($event)"
>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <!-- Icon -->
      <mat-icon *ngIf="!isLoaderVisible; else loader">bug_report</mat-icon>

      <!-- Loader -->
      <ng-template #loader>
        <mat-spinner diameter="24"></mat-spinner>
      </ng-template>

      <!-- Title -->
      <h2>{{ "debug_panel.debug_panel" | translate }}</h2>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <!-- Content -->
  <ng-container *ngIf="isAfterViewInit">
    <!-- Controls -->
    <div class="controls">
      <!-- Expand JSON Button -->
      <button
        type="button"
        mat-stroked-button
        color="primary"
        [disabled]="isToggleJsonExpansionDisabled"
        (click)="onClickToggleJsonExpansion(true)"
      >
        <mat-icon>expand_more</mat-icon
        >{{ "debug_panel.expand_json" | translate }}
      </button>

      <!-- Collapse JSON Button -->
      <button
        type="button"
        mat-stroked-button
        color="primary"
        [disabled]="isToggleJsonExpansionDisabled"
        (click)="onClickToggleJsonExpansion(false)"
      >
        <mat-icon>expand_less</mat-icon
        >{{ "debug_panel.collapse_json" | translate }}
      </button>
    </div>

    <mat-divider></mat-divider>

    <!-- Data -->
    <mat-tab-group
      (selectedIndexChange)="onSelectedIndexChangeTab($event)"
      [(selectedIndex)]="debugSettings.selectedTabIndex"
    >
      <!-- Options -->
      <mat-tab label="{{ 'debug_panel.options' | translate }}">
        <ngx-json-viewer
          [expanded]="debugSettings.isJsonExpanded"
          [json]="options"
          *ngIf="!isJsonLoading"
        ></ngx-json-viewer>
      </mat-tab>

      <!-- Form -->
      <mat-tab label="{{ 'debug_panel.form' | translate }}">
        <ngx-json-viewer
          [expanded]="debugSettings.isJsonExpanded"
          [json]="form"
          *ngIf="!isJsonLoading"
        ></ngx-json-viewer>
      </mat-tab>

      <!-- Model -->
      <mat-tab label="{{ 'debug_panel.model' | translate }}">
        <ngx-json-viewer
          [expanded]="debugSettings.isJsonExpanded"
          [json]="model"
          *ngIf="!isJsonLoading"
        ></ngx-json-viewer>
      </mat-tab>

      <!-- Shared Data -->
      <mat-tab label="{{ 'debug_panel.shared_data' | translate }}">
        <ngx-json-viewer
          [expanded]="debugSettings.isJsonExpanded"
          [json]="model.sharedData"
          *ngIf="!isJsonLoading"
        ></ngx-json-viewer>
      </mat-tab>

      <!-- Level Models -->
      <mat-tab
        [label]="
          (levelName | titlecase) + ' ' + ('debug_panel.model' | translate)
        "
        *ngFor="let levelName of levelNamesList"
      >
        <ngx-json-viewer
          [expanded]="debugSettings.isJsonExpanded"
          [json]="model[levelName]"
          *ngIf="!isJsonLoading"
        ></ngx-json-viewer>
      </mat-tab>
    </mat-tab-group>
  </ng-container>
</mat-expansion-panel>
